// Pure, dependency-free decision predicate for the Stories schedule flow.
//
// Kept in its own module (not on StoriesCard) so it stays jest-testable
// without pulling in the axios-heavy card and its modal/query graph.
//
// The backend `/posts/:id/schedule` endpoint only accepts READY/SCHEDULED
// posts. Auto-created stories start as DRAFT, so scheduling one must first
// promote it to READY. This returns true when a promotion is required.
export const needsPromoteBeforeSchedule = (status: string): boolean =>
  status !== "ready" && status !== "scheduled";
